import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../../services/shared.service";
import dictionary from "../../../../utils/dictionary.json";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { RequestModel } from "../../../../models/dashboard/request.model";
import { DashboardService } from "../../../../services/dashboard.service";
@Component({
  selector: "app-http-metadata-blocco",
  templateUrl: "./http-metadata-blocco.component.html",
  styleUrls: ["./http-metadata-blocco.component.css"],
})
export class HttpMetadataBloccoComponent implements OnInit {
  isLoading: boolean;
  blocco: any;
  tipo: string;
  json: any;

  responseTypes: Array<any> = [];

  constructor(
    private _sharedService: SharedService,
    private _dashboardService: DashboardService,
    private formBuilder: FormBuilder
  ) {}

  form: FormGroup;
  request: RequestModel;

  ngOnInit() {
    this.responseTypes = this._sharedService.getResponseTypes();
    if (!this.responseTypes) {
      this._dashboardService.getResponseTypes().subscribe((res) => {
        this.responseTypes = res;
        this._sharedService.setResponseTypes(res);
      });
    }
  }

  inizializeForm() {
    this.getBlocco();
    this.getRequest();
    this.isLoading = false;
    this.form = this.formBuilder.group({
      requestName: new FormControl(
        this.request.nome,
        Validators.compose([Validators.required])
      ),
      responseType: new FormControl(
        this.request.idBloccoHttpResponseTipo,
        Validators.compose([Validators.required])
      ),
    });
    if (this.tipo === "HTTP_Data") {
      this.form.get("requestName").disable();
      this.form.get("responseType").disable();
    }
  }

  getBlocco() {
    this.blocco = this._sharedService.getBlocco();
    this.tipo = this.blocco.tipoBlocco
      ? this.blocco.tipoBlocco
      : this.blocco.codiceBloccoTipo;
    this.json = this.blocco.json;
  }
  getRequest() {
    this.request = this._sharedService.getRequest();
  }

  onJsonChange(event) {
    this.json = event;
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/item-manager/http-metadata-blocco/http-metadata-blocco.component.ts